module.exports = __webpack_public_path__ + "static/media/BauPro-Bold.2e65d626.eot";